"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = require("./Label");
exports.Label = Label_1.Label;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0xhYmVsL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQTZCO0FBQXJCLHdCQUFBLEtBQUssQ0FBQSJ9